export const Apis = {
  Login_verifyPin: 'trillium-patient-service/v1/review/login',
  Login_submit: 'trillium-patient-service/v1/reminder/web',
  Login_getFlag: 'trillium-clinic-service/v1/messageclinicsetting',
  Unsubscribe: 'trillium-patient-service/v1/reminder/email-preferences',
  Subscribe: 'trillium-patient-service/v1/reminder/email-preferences',
}
